export enum SegmentSelect {
    REGION = 'REGION',
    DMA = 'DMA',
}

export enum MapSelectionsType {
    INTERACTIVE = 'interactive',
    STATIC = 'static',
}

export enum Localization {
    US = 'united_states',
    UK = 'united_kingdom',
}

export enum Title {}

export enum ButtonDataStatus {
    IS_BUTTON_RUN = 'isButtonRun',
    IS_DATA_LOADING = 'isDataLoading',
}

export enum Pages {
    PROJECTION = 'projection',
    CREATE_SCENARIO = 'createScenario',
    HOME = 'home',
}

export enum Tab {
    POPULATION = 'Population',
    DEMOGRAPHIC = 'Demographic',
    DISPOSABLE_INCOME = 'Disposable Income',
    CURRENT_SPEND = 'Current Spend',
    CATEGORY_SPEND = 'Category Spend',
    DRIVERS_OF_GROWTH = 'Drivers of Growth',
}

export enum AggregatedByAndSubPlotValue {
    NONE = 'None',
    INCOME_BRACKET = 'INCOME_BRACKET',
    SEX = 'SEX',
    AGE_GROUP = 'AGE_GRP',
    ETHNIC_GROUP = 'ETH_GRP',
    SUBCATEGORY = 'SUBCATEGORY',
    GEO_NAME = 'GEO_NAME',
    ALL_POPULATION = 'All population',
    AGGREGATED = 'Aggregated',
    ETHNICALLY_GROUPS = 'Ethnically diverse groups',
    SOCIO_ECONOMIC = 'SEM_scenario',
    DRIVER = 'Driver',
}

export enum AggregatedByAndSubPlotLabel {
    SUBCATEGORIES = 'Subcategories',
    ETHNIC_GROUP = 'Ethnic group',
    AGE = 'Age',
    SEX = 'Sex',
    DISPOSABLE_INCOME = 'Disposable income',
    GEOGRAPHY = 'Geography',
    NO_AGGREGATION = 'No aggregation',
    TOTAL_POPULATION = 'Total population',
    COMBINED_MULTICULTURAL = 'Combined multicultural',
    SOCIOECONOMIC = 'Socioeconomic scenario',
    DRIVER = 'Driver',
}

export enum DropdownSelection {
    SHOW_BY = 'isShowByShowing',
    GROUP_BY = 'isGroupByShowing',
    X_AXIS = 'isXAxisShowing',
}

export enum DropdownTexts {
    GROUP_BY_DESCRIPTION = 'Breaks down the projections into the subgroups from your dropdown selection. Each subgroup is a different legend color.',
    SHOW_BY_DESCRIPTION = 'Visualizes the projections as different plots based on your dropdown selection.',
    X_AXIS_DESCRIPTION = 'Sets the x-axis based on your dropdown selection, allowing you to visualize how the data is distributed across different values on the horizontal axis.',
}

export enum SideModalTitle {
    POPULATION_GROUPS = 'Population groups',
    DEMOGRAPHIC_GROUPS = 'Demographic groups',
    MOBILITY_SCENARIOS = 'Mobility scenarios',
    CATEGORIES = 'Categories',
    POPULATION_SPEND = 'Population vs spend',
    INCOME_LEVELS = 'Income levels',
    HOW_TO_USE = 'How to use',
    COMPLIANCE = 'Compliance',
    DEFAULT = 'default',
}

export enum Region {
    WEST = 'West',
    MIDWEST = 'Midwest',
    SOUTH = 'South',
    NORTHEAST = 'Northeast',
}

export enum Dma {
    ATLANTA_GA = 'Atlanta GA',
    BOSTON_MA = 'Boston MA (Manchester NH)',
    CHICAGO_IL = 'Chicago IL',
    DALLAS_FT = 'Dallas-Ft.Worth TX',
    HOUSTON_TX = 'Houston TX',
    LOS_ANGELES_CA = 'Los Angeles CA',
    NEW_YORK_NY = 'New York NY',
    PHILADELPHIA_PA = 'Philadelphia PA',
    SAN_FRANCISCO_CA = 'San Francisco-Oakland-San Jose CA',
    WASHINGTON_DC = 'Washington DC (Hagerstown MD)',
}

export enum SliceTypes {
    GEO_MAP = 'geoMap',
    CREATE_SCENARIO = 'createScenario',
    PROJECTIONS = 'projections',
    SERVICE = 'service',
    SIDEPANEL = 'sidePanel',
    REDIRECT_BUTTON = 'redirectButton',
}

export enum SelectionScenarioSex {
    MALES = 'males',
    FEMALES = 'females',
}

export enum SelectionPanelSexLabel {
    MALE = 'Male',
    FEMALE = 'Female',
}

export enum SelectionPanelSexValue {
    MALE = 'M',
    FEMALE = 'F',
}

export enum SelectionAge {
    GROUP_LESS_18 = '< 18',
    GROUP_LESS_16 = '< 16',
    GROUP_15_20 = '15-20',
    GROUP_16_24 = '16-24',
    GROUP_18_24 = '18-24',
    GROUP_25_29 = '25-29',
    GROUP_LESS_30 = '<30',
    GROUP_21_30 = '21-30',
    GROUP_25_34 = '25-34',
    GROUP_30_39 = '30-39',
    GROUP_31_40 = '31-40',
    GROUP_40_49 = '40-49',
    GROUP_41_50 = '41-50',
    GROUP_35_49 = '35-49',
    GROUP_50_64 = '50-64',
    GROUP_51_60 = '51-60',
    GROUP_LESS_60 = '< 60',
    GROUP_65_PLUS = '65+',
}

export enum SelectionHeritage {
    EAST_AND_SOUTH_ASIAN = 'East & Southeast Asian',
    SOUTH_ASIAN_PAKISTANI = 'South Asian, Pakistani',
    SOUTH_ASIAN_BANGLADESHI = 'South Asian, Bangladeshi',
    SOUTH_ASIAN_INDIAN = 'South Asian, Indian',
    MIDDLE_EASTERN = 'Middle Eastern',
    MIXED = 'Mixed',
    WHITE = 'White',
    BLACK = 'Black',
    ASIAN = 'Asian',
    HISPANIC_ANY_RACE = 'Hispanic, any race',
    MIXED_AND_OTHER = 'Mixed & Other',
    MIXED_AND_OTHER_RACES = 'Mixed, other races',
    MIXED_AND_ADDITIONAL = 'Mixed race + Additional races',
}

export enum SelectionCategory {
    CONSUMER_ELECTRONICS = 'Consumer electronics',
    ALCOGOLIC_BEVERAGES = 'Alcoholic beverages',
    GROCERY = 'Grocery',
    GROCERIES = 'Groceries',
    INSURANCE = 'Insurance',
    NON_ALCOHOLIC_BEVERAGES = 'Non-alcoholic beverages',
    SPORTS_AND_RECREATION = 'Sports & recreation',
    SUBSCRIPTION = 'Subscriptions',
    FINANCIAL_PRODUCTS_AND_SERVICES = 'Financial products & services',
    EATING_AND_DRINKING_OUT = 'Eating & drinking out',
    CLOTHING_AND_FASHION = 'Clothing & fashion',
    BEAUTY_AND_PERSONAL_CARE = 'Beauty & personal care',
}

export enum SelectionFinancialProducts {
    SAVINGS = 'Savings',
    INSURANCE = 'Insurance',
}

export enum SelectionEatingAndDrinking {
    DRINKING_OUT_ALCOHOL = 'Drinking (alcohol) out',
    DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES = 'Drinking alcohol out',
    EATING_OUT = 'Eating out',
    TAKEAWAY = 'Takeaway',
}

export enum SelectionClothingFashion {
    ADULT = 'Adult clothing',
    CHILDREN = "Children's clothing",
}

export enum SelectionBeautyCare {
    HAIR_AND_COSMETICS = 'Hair & cosmetics',
    TOILETRIES_AND_SOAP = 'Toiletries & soap',
    TREATMENTS = 'Treatments',
}

export enum SelectionAlcoBeverages {
    WINE = 'Wine',
    BEER_AND_ALE = 'Beer & ale',
    OTHER = 'Other, including spirits',
}

export enum SelectionConsumerElectro {
    E_READERS = 'eReaders',
    TELEVISIONS = 'Televisions',
    VIDEO_GAMES = 'Video games',
    PERSONAL_CARE = 'Personal care',
    AUDIO_EQUIP = 'Audio equipment',
    COMPUTERS_AND_LAPTOPS = 'Computers & laptops',
    CELLPHONES = 'Cellphones & accessories',
    SMALL_KITCHEN_APPLIANCES = 'Small kitchen appliances',
}

export enum SelectionGrocery {
    BAKED_GOODS = 'Baked goods',
    GENERAL_FOOD = 'General food stuffs',
    CLEANING_AND_HYGIENE = 'Cleaning & hygiene',
    PET_FOOD = 'Pet food',
    SWEET_AND_SNACKS = 'Sweets & snacks',
    ALCOHOL_AT_HOME = 'Alcohol (At home)',
    ALCOHOL_AT_HOME_WITHOUT_BRACES = 'Alcohol at home',
    BABYCARE = 'Babycare',
    CLEANING_PRODUCTS = 'Cleaning products',
    FOOD = 'Food',
    NEWSPAPERS_AND_MAGAZINES = 'Newspapers & magazines',
    PETCARE = 'Petcare',
}

export enum SelectionInsurance {
    HEALTH = 'Health',
    VEHICLE = 'Vehicle',
    HOMEOWNER = 'Homeowner',
    LIFE_AND_PERSONAL = 'Life & personal',
}

export enum SelectionNonAlcogolic {
    TEA = 'Tea',
    COLA = 'Cola',
    JUICE = 'Juice',
    OTHER = 'Other',
    WATER = 'Water',
    COFFEE = 'Coffee',
    SPORTS_DRINKS = 'Sports drinks',
    SODA = 'Soda (excluding cola)',
}

export enum SelectionSports {
    CLUB_MEMBERSHIPS = 'Club memberships',
    PARTICIPATION_FEES = 'Participation fees',
    EVENT_TICKETS = 'Sporting event tickets',
}

export enum SelectionSubscription {
    AUDIO_STREAMING = 'Audio streaming',
    BOOKS_AND_EBOOKS = 'Books & eBooks',
    SHOPPING_MEMBERSHIP = 'Shopping club memberships',
    VIDEO_STREAMING = 'Video streaming',
}

export enum SelectionIncome {
    GROUP_LESS_10k = '< $10,000',
    GROUP_10k_TO_25k = '$10,000-25,000',
    GROUP_25k_TO_50k = '$25,000-50,000',
    GROUP_50k_TO_75k = '$50,000-75,000',
    GROUP_75k_TO_100k = '$75,000-100,000',
    GROUP_ABOVE_100k = '> $100,000',
    GROUP_LOW_INCOME = 'Low income',
    GROUP_MID_INCOME = 'Mid-level income',
    GROUP_HIGH_INCOME = 'High income',
}

export enum SelectionHighlighted {
    TOTAL_DEFINED_SEGMENT = 'Total defined segment',
    SEX = 'Sex',
    AGE_GROUP = 'Age group',
    ETHNIC_GROUP = 'Ethnic group',
    CATEGORY = 'Category',
    SUBCATEGORY = 'Subcategory',
    NONE = 'None selected',
    DEMOGRAPHIC_POPULATION = 'Demographic population',
    CATEGORY_SPEND = 'Category spend',
}

export enum SelectionPerAnnum {
    CUMULATIVE = 'Cumulative',
    PER_ANNUM = 'Per annum',
}

export enum FetchTypes {
    SCENARIO_PLOTS = 'fetchScenarioPlots',
    SCREEN_PLOTS = 'fetchScreenPlots',
    HARE = 'fetchHare',
    TORTOISE = 'fetchTortoise',
}

export enum SelectionInconsistentLabel {
    BEER_AND_ALE = 'Beer & Ale',
    GENERAL_FOOD = 'General food',
    SWEET_AND_SNACKS = 'Sweets, candy, snacks',
}

export enum SelectionPlotlyLegend {
    RAPID_SOCIOECONOMIC = 'Rapid socioeconomic mobility',
    PERSISTENT_SOCIOECONOMIC = 'Persistent socioeconomic mobility',
    NO_SOCIOECONOMIC = 'No socioeconomic mobility',
    RESTRICTED_SOCIOECONOMIC = 'Restricted socioeconomic mobility',
    BASELINE = 'Baseline',
    ADULT_POPULATION_ABOVE_16 = 'Adult population (≥16)',
    ADULT_POPULATION_ABOVE_15 = 'Adult population (≥15)',
    MIXED = 'Mixed',
    SOUTH_ASIAN_INDIAN = 'South Asian, Indian',
    SOUTH_ASIAN_PAKISTANI = 'South Asian, Pakistani',
    SOUTH_ASIAN_BANGLADESHI = 'South Asian, Bangladeshi',
    EAST_AND_SOUTHEAST_ASIAN = 'East & Southeast Asian',
    MINORITY_GROUPS = 'Minority ethnic groups',
    MIDDLE_EASTERN = 'Middle Eastern',
    HIGH_INCOME = 'High income',
    MID_LEVEL_INCOME = 'Mid-level income',
    LOW_INCOME = 'Low income',
    GROCERIES = 'Groceries',
    PER_PERSON_SPEND = 'Per person spend',
    SPEND = 'Spend',
    CATEGORY_SPEND_CUMULATIVE = 'Category spend (cumulative)',
    CATEGORY_SPEND_PER_ANNUM = 'Category spend (per annum)',
    ADULT = 'Adult',
    CHILDREN = 'Children',
    TOBACO_AND_NARCOTICS = 'Tobacco & narcotics',
    TOILET_PAPER = 'Toilet paper',
    MIXED_AND_ADDITIONAL_RACES = 'Mixed race & Additional races',
    ADULT_18_PLUS = 'Adult population (18+)',
    ADULT_16_PLUS = 'Adult population (16+)',
    ADULT_15_PLUS = 'Adult population (15+)',
}
